export default "/_next/static/chunks/fonts/Channel4Chadwick-Medium-656a383eea8915a3231e77c8e1f185e4.woff";